import React, { useContext, useEffect, useState } from "react";
import "./styles.less";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import OptionsLabel from "./OptionsLabel";
import { ContactUs } from "./ContactUs";
import FAQPage from "./FAQ";
import AdvertiseWithUs from "./AdvertiseWithUs";
import Safety from "./Safety";
import TyC from "./TyC";
import PoliciesAndPrivacy from "./PoliciesAndPrivacy";
import LegalWarning from "./LegalWarning";
import CookiesPolicies from "./CookiesPolicies";
import { useRouter } from "next/router";
import SkeletonAboutUs from "./SkeletonAboutUs";

const AboutUs = () => {
	const { asPath, isReady, push } = useRouter();
	const [activeOption, setActiveOption] = useState<string>("contactanos");
	const { country_code, main_domain, site_name } = useContext(ConfigStateContext);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (isReady) {
			const hash = asPath.split("#")[1];
			setActiveOption(hash || "contactanos");
		}
	}, [isReady, asPath]);

	useEffect(()=>{
		if(country_code){
			setLoading(false);
		}
		else setLoading(true)
	},[country_code])

	const handleOptionClick = (option: string) => {
		setActiveOption(option);
		push(`#${option}`, undefined, { shallow: true });
	};

	const renderContent = () => {
		const contentMap = {
			"preguntas-frecuentes": (
				<FAQPage country_code={country_code} main_domain={main_domain} site_name={site_name} />
			),
			"contactanos": <ContactUs />,
			"anuncia-con-nosotros": (
				<AdvertiseWithUs main_domain={main_domain} country_code={country_code} />
			),
			"recomendaciones-de-seguridad": country_code === 'CO' && (
				<Safety main_domain={main_domain} />
			),
			"terminos-y-condiciones": <TyC country_code={country_code} />,
			"politicas-de-privacidad": <PoliciesAndPrivacy country_code={country_code} />,
			"aviso-legal": <LegalWarning main_domain={main_domain} />,
			"politicas-de-cookies": country_code === "CO" && (
				<CookiesPolicies country_code={country_code} site_domain={main_domain} site_name={site_name} />
			)
		};

		return contentMap[activeOption] || null;
	};

	return loading ? <SkeletonAboutUs/>:(
		<div className="aboutUs">
			<div className="aboutUs__options">
				<OptionsLabel onOptionClick={handleOptionClick} />
			</div>
			<div className="aboutUs__content">
				{renderContent()}
			</div>	
		</div>
	)
};

export default AboutUs;
